import { faTrash } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx/lite";
import { FocusEvent } from "react";

type AttendanceMobileHoursInputProps = {
  label: string;
  value: string;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  onBlur: (event: FocusEvent<HTMLInputElement>) => void;
  onChange: (value: string) => void;
  disabled: boolean;
  onRemove?: () => void;
};

export function AttendanceMobileHoursInput({
  label,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled,
  onRemove,
}: AttendanceMobileHoursInputProps) {
  return (
    <div className="flex flex-row justify-between items-center w-full">
      <div className="flex flex-row gap-3 items-center">
        {onRemove && (
          <button onClick={onRemove}>
            <FontAwesomeIcon
              icon={faTrash}
              className="text-font-secondary text-lg"
            />
          </button>
        )}
        <div>{label}</div>
      </div>

      <input
        disabled={disabled}
        onFocus={onFocus}
        className={clsx(
          "border-b",
          "border-b-neutral",
          "w-12",
          "text-center",
          "outline-none",
          disabled ? "text-font-secondary" : "text-font-black",
        )}
        onBlur={onBlur}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}
